import React from 'react';
import { Helmet } from 'react-helmet';

const businessSchema = {
  '@context': 'https://schema.org',
  '@type': 'GeneralContractor',
  name: 'Dino Construction',
  url: 'https://dinoconstructions.com/',
  email: 'Dino@DinoConstructions.com',
  telephone: '+1-828-702-8101',
  image: 'https://dinoconstructions.com/android-chrome-512x512.png',
  areaServed: [
    {
      '@type': 'City',
      name: 'Asheville',
      addressRegion: 'NC',
      addressCountry: 'US',
    },
    {
      '@type': 'AdministrativeArea',
      name: 'Western North Carolina',
    },
  ],
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '07:00',
      closes: '18:00',
    },
  ],
  makesOffer: [
    { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Concrete services' } },
    { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Roofing services' } },
    { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Decks, porches, and fences' } },
    { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Painting services' } },
    { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Stone patio construction' } },
    { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Block foundation services' } },
  ],
};

function SiteSchema() {
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(businessSchema)}
      </script>
    </Helmet>
  );
}

export default SiteSchema;
